import plugin from '../src/keep-aspect.plugin.js';

(typeof gobalThis !== 'undefined' ? globalThis : window).gySVG.extend (plugin);
